<template>
    <div id="contract_type_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Contract Type List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddConType" class="btn btn-primary pull-right" v-bind:to="{name: 'ContractTypeCreate'}" > <i class="fp-add"> </i> Add </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contract-type-list">
                        <data-table-filter-config :moduleName="'contractTypeList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'contractTypeList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listContractTypeTable"
                                    mode="remote"
                                    title="ContractType"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :rows="rows"
                                    @on-select-all="onSelectAll"
                                    :columns="userColumns"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Contract Type" v-if="canUpdateConType" class="fp-edit" v-bind:to="{name: 'ContractTypeEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="canRemoveConType" id="deleteContractTypeBtn" v-on:click.prevent="ContractTypeDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ContractTypeList",
        metaInfo() {
            return {title: "Contract Type List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Contract Type Code',
                    field: 'code',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type Name',
                    field: 'name',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billing Frequency',
                    field: 'frequency',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Billing Frequency", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            action:'list',
            canAddConType:false,
            canUpdateConType:false,
            canRemoveConType:false,
            pageKey:"_contract_type_list_",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_contract_type') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_contract_type') {
                            self.canAddConType = true;
                            self.canUpdateConType = true;
                        }
                        if (permissions[i].name == 'delete_contract_type') {
                            self.canRemoveConType = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listContractTypeTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('code');
                    field:('name');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.code || filters.name) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                var data = this.$refs['listContractTypeTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listContractTypeTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:use,
                    action:self.action,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/contracttype/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if ( self.action == 'delete'){
                            self.action = 'list';
                            self.loadList();

                        }
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == 'delete') {
                            self.generateStatusCodeMessage(jqXHR, true, 'load-contract-type-list')
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'load-contract-type-list')
                        }
                    }
                });
            },
            ContractTypeDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Contract Type?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ContractTypeList.vue